export const toUniqueRowIds = (ids: string[]): string[] =>
  ids.map((id, index) => `${id}-${index}`);
